import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { IconHighlighted } from '@kubit/web-ui-product-components';
const IconHighlightedComponent = (props) => (_jsx(IconHighlighted, { ...props }));
export { IconHighlightedComponent };
//# sourceMappingURL=icon-highlighted.component.js.map